export default {
    data() {
      return {
        email: 'mister.britto@hotmail.com',
        linkedin: 'https://www.linkedin.com/in/lucaas-britto/',
        github: 'https://github.com/lucaasbritto',
        photoUrl: require('@/assets/imagens/config/foto_lucas.jpeg')
      };
    }
  };